<template>
  <tab-layout>
    <li slot="tabHeading" class="nav-item">
      <a :class="['nav-link', selectedTab === 'details' ? 'active' : '']" href @click.prevent="selectedTab = 'details'" id="details-tab" data-toggle="tab" role="tab" aria-controls="details" :aria-selected="selectedTab === 'details' ? 'true' : 'false'">My Details</a>
    </li>
    <li slot="tabHeading" class="nav-item" v-if="memberDetails">
      <a :class="['nav-link', selectedTab === 'membership' ? 'active' : '']" href @click.prevent="selectedTab = 'membership'" id="membership-tab" data-toggle="tab" role="tab" aria-controls="membership" :aria-selected="selectedTab === 'membership' ? 'true' : 'false'">My Membership</a>
    </li>
    <li slot="tabHeading" class="nav-item" v-if="memberDetails && userRole !=='Volunteer' ">
      <a :class="['nav-link', selectedTab === 'financials' ? 'active' : '']" href @click.prevent="selectedTab = 'financials'" id="financials-tab" data-toggle="tab" role="tab" aria-controls="financials" :aria-selected="selectedTab === 'financials' ? 'true' : 'false'">My Financials</a>
    </li>
    <li slot="tabHeading" class="nav-item" v-if="memberDetails && userRole !=='Volunteer' ">
      <a :class="['nav-link', selectedTab === 'history' ? 'active' : '']" href @click.prevent="selectedTab = 'history'" id="history-tab" data-toggle="tab" role="tab" aria-controls="history" :aria-selected="selectedTab === 'history' ? 'true' : 'false'">My History</a>
    </li>
    <member-profile-details
      v-if="selectedTab === 'details'"
      :memberDetails="memberDetails"
      :my="true"
      :completePaymentProfile="completePaymentProfile"
      :returnTo="returnTo"
      @renew="renew = true;selectedTab = 'membership'"
      slot="tabContent"
      class="tab-pane row mx-0 show active"
      id="details"
      role="tabpanel"
      aria-labelledby="details-tab" />
    <member-profile-membership
      v-if="selectedTab === 'membership'"
      :my="true"
      :child="child"
      :memberDetails="memberDetails"
      :renew="renew"
      @noRenew="renew = false"
      slot="tabContent"
      class="tab-pane row mx-0 show active"
      id="membership"
      role="tabpanel"
      aria-labelledby="membership-tab" />
    <member-profile-financials
      v-if="selectedTab === 'financials'"
      :memberID="memberDetails.id"
      slot="tabContent"
      class="tab-pane col-md-11 col-lg-10 col-xl-9 px-0 bg-white rounded mb-4 p-3 p-sm-4 show active"
      id="financials"
      role="tabpanel"
      aria-labelledby="financials-tab" />
    <member-profile-history
      v-if="selectedTab === 'history'"
      :memberID="memberDetails.id"
      :membership_options="memberDetails.membership_options"
      slot="tabContent"
      class="tab-pane col-md-11 col-lg-10 col-xl-9 px-0 bg-white rounded mb-4 p-3 p-sm-4 show active"
      id="history"
      role="tabpanel"
      aria-labelledby="history-tab" />
  </tab-layout>
</template>

<script>
/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */
// 'My Profile'
import tabLayout from '@/components/TabLayout'
import GETSTORE from '@/store/memberProfileStore.js'
import memberProfileDetails from '@/views/Members/Tabs/Details'
import memberProfileFinancials from '@/views/Members/Tabs/Financials'
import memberProfileHistory from '@/views/Members/Tabs/MembershipHistory'
import memberProfileMembership from './MyMembershipMembership'

export default {
  props: ['renewing', 'tabSelect', 'child', 'completePaymentProfile', 'returnTo'],
  name: 'MyMembership',
  mixins: [GETSTORE],
  components: {
    'tab-layout': tabLayout,
    'member-profile-details': memberProfileDetails,
    'member-profile-membership': memberProfileMembership,
    'member-profile-financials': memberProfileFinancials,
    'member-profile-history': memberProfileHistory
  },
  data() {
    return {
      selectedTab: this.tabSelect ? this.tabSelect : 'details',
      renew: this.renewing ? this.renewing : false,
      userID: localStorage.userID,
      userRole: localStorage.role
    }
  },
  watch: {
    selectedTab() {
      if (this.selectedTab === 'details' && !this.memberDetails) {
        this.memberDetails = this.$store.state.viewedMember || this.$store.state.childMember
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/MyMembership/MyMembershipProfile.vue